import { Component } from '@angular/core';
//import { IonicPage, NavController, NavParams,ActionSheetController,LoadingController } from 'ionic-angular';
import { IonicPage,AlertController, NavController, NavParams,ActionSheetController,ModalController,LoadingController } from 'ionic-angular';

import { CommonProvider } from '../../providers/common/common';
import { GenericFormValidationProvider } from '../../providers/common/form-validation';
import { PropertyDocumentPickupPage } from '../property-document-pickup/property-document-pickup';
import { CoPersonaldetailsPage } from '../co-personaldetails/co-personaldetails';
import { LeadThankYouPage } from '../lead-thank-you/lead-thank-you';
import {FileuploadPage} from "../fileupload/fileupload"
import { Observable } from "rxjs/Observable";
import 'rxjs/add/observable/forkJoin'

@IonicPage()
@Component({
  selector: 'page-property-document-list',
  templateUrl: 'property-document-list.html',
})
export class PropertyDocumentListPage {
  arrCheckList:any=[];
  applicants:any=[];
  countDocumentUploaded:any=[];
  arrHeaders:any=[];
  constructor(private loadingCtrl:LoadingController,
      private alertCtrl:AlertController,
    public modalCtrl: ModalController,public actionSheetCtrl: ActionSheetController,private fv:GenericFormValidationProvider, public navCtrl: NavController, public navParams: NavParams,private cp:CommonProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PropertyDocumentListPage',this.navParams.data);
    this.getDocList();
  }

  goToPickupDocument(){

// this.navCtrl.push(PropertyDocumentPickupPage,this.navParams);
    this.navCtrl.push(PropertyDocumentPickupPage,{"leadid":JSON.parse(this.navParams.data.data).Payload.lead.leadid})
  }
  getDocList(){
    // console.log()
   let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
   loading.present()
   let request:any={};


  var applicant=JSON.parse(this.navParams.data).Payload.lead.applicants.filter((res:any)=>{
    return res.ibhfl_applicantrole==303710000
  })

  this.applicants=applicant;
  request.ApplicantID=applicant[0].applicantid
  this.cp.getDocList(loading,request).then((res:any)=>{
                            loading.dismiss();
                            var res=JSON.parse(res)

                            this.arrCheckList=res.Payload
                            console.log(res.Payload);
                           })
  
}
uploadDocument(checkList?:any,doc_type?:any){

  const modal = this.modalCtrl.create(FileuploadPage,{showBackdrop: false,
                      enableBackdropDismiss: false});
            modal.onDidDismiss((fetchFileData) => {
              
              if(!fetchFileData){

              }else{
                this.countDocumentUploaded[checkList.ccs_documentchecklistid]=fetchFileData.document
                this.arrHeaders[checkList.ccs_documentchecklistid]=doc_type;
              }
            })
            modal.present()
}
submitDoucument(){
     
     if(this.arrCheckList.length==Object.keys(this.countDocumentUploaded).length){
             

            let loading = this.loadingCtrl.create({
                  content: 'Please wait...'
                });
               loading.present()
               
              //this.countDocumentUploaded[checkList.ccs_documentchecklistid]=fetchFileData.document
              var arrForkJoinREquest=[]
              Object.keys(this.countDocumentUploaded).forEach((key)=>{
                let request:any={};
                // if(key=='0ea1b098-9dc0-e811-a963-000d3af025eb'),'06a1b098-9dc0-e811-a963-000d3af025eb'
                request.documentchecklistid = key;
                 if(this.arrHeaders[key]=="3 Month's Salary Slip"){
                  request.DocumentHeaderId="0ea1b098-9dc0-e811-a963-000d3af025eb"
                 }
                 if(this.arrHeaders[key]=="Last 6 Months Bank Statement"){
                  request.DocumentHeaderId="06a1b098-9dc0-e811-a963-000d3af025eb"
                 }
                  
                arrForkJoinREquest.push(this.cp.uploadApi(loading,request,this.countDocumentUploaded[key]))
                ;
              })

              if(arrForkJoinREquest.length>0){
                Observable.forkJoin(arrForkJoinREquest)
                .subscribe((res:any) => {
                  loading.dismiss();
                  console.log(this.applicants);
                  if(this.applicants[0].ibhfl_addcoapplicantincome){
                    this.navCtrl.push(CoPersonaldetailsPage,this.navParams)
                  }else{
                    this.navCtrl.setRoot(LeadThankYouPage,this.navParams)
                  }
                })
              }
      }else{
      this.showAlert("upload all requirement document")
     }
  }
  showAlert(msg) {

      
      const alert = this.alertCtrl.create({
        title: 'Error',
        subTitle: msg,
        buttons: ['OK']
      });
      alert.present();
    }
}



// WEBPACK FOOTER //
// ./src/pages/property-document-list/property-document-list.ts